(function() {
    angular.module('ngmvac').filter('sliderFilter', SliderFilter);
    function SliderFilter() {       
        return function(arr, min, max, noches) {
            max = parseInt(max) + 1;
            min = parseInt(min) - 1;
            var arrAux2 = [];
            angular.forEach(arr, function(hotel) {
                var clHotel = {};
                for (property in hotel) {
                    clHotel[property] = hotel[property];
                }
                clHotel.packageGrouped = [];
                if(hotel.rates == 1){
                    angular.forEach(hotel.packageGrouped, function(group) {
                        clHotel.packageGrouped.push([]);
                        angular.forEach(group, function(pack, index) {
                            if(index == 0){
                                var pack_  = Math.round(pack.price/ noches);
                                if (pack_ >= min && pack_ <= max) {
                                    clHotel.minPackage = pack;
                                    clHotel.packageGrouped[clHotel.packageGrouped.length - 1].push(pack);
                                }
                            }
                        });
                        if (clHotel.packageGrouped[clHotel.packageGrouped.length - 1].length == 0) {
                            clHotel.packageGrouped.splice(clHotel.packageGrouped.length - 1, 1);
                        }
                    });
                }
                if (clHotel.packageGrouped.length > 0) {
                    if(clHotel.rates == 0 ){
                        delete clHotel.packageGrouped;
                    }
                    arrAux2.push(clHotel);
                }
            });
            return arrAux2;
        }
    }
})();